import { supabase } from "@/infrastructure/supabase/client";
import type { StakeholderRow } from "@/infrastructure/supabase/database.types";

export interface StakeholderFilters {
  org?: StakeholderRow["org"];
  area?: NonNullable<StakeholderRow["area"]>;
  search?: string;
}

export const stakeholdersRepository = {
  async list(filters: StakeholderFilters = {}): Promise<StakeholderRow[]> {
    let q = supabase.from("stakeholders").select("*").order("name", { ascending: true });
    if (filters.org) q = q.eq("org", filters.org);
    if (filters.area) q = q.eq("area", filters.area);
    if (filters.search) q = q.ilike("name", `%${filters.search}%`);
    const { data, error } = await q;
    if (error) throw error;
    return data ?? [];
  },

  async byId(id: string): Promise<StakeholderRow | null> {
    const { data, error } = await supabase
      .from("stakeholders")
      .select("*")
      .eq("id", id)
      .maybeSingle();
    if (error) throw error;
    return data;
  },

  async create(
    input: Omit<StakeholderRow, "id" | "created_at" | "updated_at">
  ): Promise<StakeholderRow> {
    const { data, error } = await supabase.from("stakeholders").insert(input).select("*").single();
    if (error) throw error;
    return data;
  },

  async update(id: string, patch: Partial<StakeholderRow>): Promise<StakeholderRow> {
    const { data, error } = await supabase
      .from("stakeholders")
      .update(patch)
      .eq("id", id)
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("stakeholders").delete().eq("id", id);
    if (error) throw error;
  },
};
